import { useState } from "react";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const MembersCell = ({ e }) => {
  const [members, setMembers] = useState(e.members || []);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const openDlg = () => { setText(members.join("\n")); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/diplomas/members/${e.id}`, { members: text.split("\n") });
      setMembers(data.members);
      setOpen(false);
      toast.success(data.members.length ? `Zapisano skład: ${data.members.length} os.` : "Wyczyszczono skład");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <div>{e.name}</div>
      {e.is_team && (
        <div className="flex flex-wrap items-center gap-2 mt-1">
          <span data-testid={`dip-members-info-${e.id}`} className="text-[11px] text-slate-400">
            {members.length ? `Dyplomy dla: ${members.join(", ")}` : "Brak składu – 1 dyplom na zespół"}
          </span>
          <button data-testid={`dip-members-btn-${e.id}`} onClick={openDlg} className="text-[11px] text-blue-300 hover:underline inline-flex items-center gap-1"><Users className="w-3 h-3" />skład</button>
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1C2541] border-blue-500/30 w-[95vw] max-w-md" data-testid="dip-members-dialog">
          <DialogHeader><DialogTitle className="font-display text-xl uppercase">Skład: {e.name}</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-400">Wpisz każdą osobę w osobnej linii – każda dostanie własny dyplom. Puste pole = dyplomy według nazwy zespołu.</p>
          <textarea data-testid="dip-members-textarea" value={text} onChange={(ev) => setText(ev.target.value)} rows={8}
            className="w-full p-3 rounded-xl bg-[#0B132B] border border-blue-500/20 focus:border-blue-500 outline-none text-sm" placeholder={"Anna Kowalska\nMaria Nowak"} />
          <button data-testid="dip-members-save" disabled={busy} onClick={save} className="h-11 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold disabled:opacity-40">Zapisz skład</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
